import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { SiteConfigAPI } from '../lib/api';

// Defaults — utilisés tant que rien n'est défini en BDD
const DEFAULTS = {
  'site.title': 'Comptoir',
  'site.tagline': 'Comptoir dentaire pro · Algérie',
  'site.contact.phone': '+213 21 00 00 00',
  'site.contact.email': 'contact@comptoir-online.com',
  'site.contact.address': 'Cité des affaires, Bab Ezzouar, Alger',
  'home.hero.title': "L'achat dentaire enfin transparent",
  'home.hero.subtitle': 'Comparez les prix de tous nos fournisseurs locaux et commandez en quelques clics.',
  'home.hero.image': '',
  'home.hero.cta_label': 'Explorer le catalogue',
  'home.hero.cta_url': '/',
  'home.banner.enabled': false,
  'home.banner.text': '',
  'home.banner.url': '',
  'home.testimonials': [],
  'home.brands_order': [],
  'home.featured_product_ids': [],
  'home.sections_order': ['occasion','featured','savings','howitworks','popular','brands','services','testimonials','blog'],
  'home.sections_hidden': [],
  'home.popular_excluded': [],
  'home.popular_added': [],
};

const SiteConfigContext = createContext({ config: DEFAULTS, loading: true, refresh: () => {} });

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await SiteConfigAPI.public();
      setConfig({ ...DEFAULTS, ...data });
    } catch {
      setConfig(DEFAULTS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteConfigContext.Provider value={{ config, loading, refresh }}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => useContext(SiteConfigContext);
export const siteText = (config, key) => config?.[key] ?? DEFAULTS[key] ?? '';
